export const EShapeActionValueType = wcardinal.ui.EShapeActionValueType;